<template src="../templates/normal_fcont_168.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadiPrint from '../components/AppDownloadiPrint'
import AppDownloadSmartPanel from '../components/AppDownloadSmartPanel'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,InfoMachineTranslation,
    AppDownloadiPrint,AppDownloadSmartPanel
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['168-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['168-3']}
      ]
    };
  }
  
};
</script>
<style scoped>
h4.title-template{
    margin-top: 30px;
    margin-bottom: 0px;
}
</style>

